import type { ComponentsOverrides, ComponentsVariants, ComponentsProps } from '@mui/material';
import type { ImgHTMLAttributes } from 'react';

export enum ImageVariants {
  default = 'default',
  circle = 'circle',
  bordered = 'bordered'
}

export interface Columns {
  [key: string]: number | undefined;
}

export interface ImageProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'width' | 'height' | 'sizes'> {
  src?: string;
  className?: string;
  columns?: Columns | undefined;
  priority?: boolean;
  itemProp?: string;
  testId?: string;
  media?: string;
  width?: number | string | `${number}` | undefined;
  height?: number | string | `${number}` | undefined;
  disableInlineSVG?: boolean;
  nextImageOptimization?: boolean; // ✅ You might want to remove this too since you're disabling Next.js optimization globally
  q?: number;
  unoptimized?: boolean;
  svgContent?: string;
  aspectRatio?: string;
  variant?: ImageVariants;
}

export interface ImageOwnerState extends ImageProps {}

//TODO: Use styled for Image
interface ImageClasses {
  root: string;
}

export declare type ImageClassKey = keyof ImageClasses;

declare module '@mui/material/styles' {
  export interface ComponentNameToClassKey {
    Image: ImageClassKey;
  }

  export interface ComponentsPropsList {
    Image: ImageProps;
  }
}

declare module '@mui/material/styles' {
  interface Components {
    Image?: {
      defaultProps?: ComponentsProps['Image'];
      styleOverrides?: ComponentsOverrides<Theme>['Image'];
      variants?: ComponentsVariants['Image'];
    };
  }
}
